import { render } from "./OrderEspagoForm.vue?vue&type=template&id=0df8104a"
import script from "./OrderEspagoForm.vue?vue&type=script&lang=js"
export * from "./OrderEspagoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__